import { render, staticRenderFns } from "./PinList.vue?vue&type=template&id=167003c0&scoped=true"
import script from "./PinList.vue?vue&type=script&lang=js"
export * from "./PinList.vue?vue&type=script&lang=js"
import style0 from "./PinList.vue?vue&type=style&index=0&id=167003c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167003c0",
  null
  
)

export default component.exports